module.exports = __webpack_public_path__ + "static/media/lightbulb-black-background.f478d6bc.jpg";